import React from "react";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { IManualSahraOrderTableReport } from "../../../Interfaces/manualInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";
import { ManualSahraOrdersTableAdditional } from "./Additional";

const TableUI: React.FC<ITableUI<IManualSahraOrderTableReport>> = ({
  reports,
  onAction,
}: ITableUI<IManualSahraOrderTableReport>) => {
  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={ManualSahraOrdersTableAdditional}
    />
  );
};

export default TableUI;
